import React from "react";

const AkontacijaStrana = ({ podaci }) => {
  const {
   		zavodniBroj,
      markaItip, 
      vrstaVozila,
      VIN,
		  brojMotora,
		  registracija,
		  godinaProizvodnje,
		  firma,
		  adresaFirma,
      datumKreiranja
  } = podaci ?? {};



  // const nbspIfEmpty = (v) =>
  //   v === 0 ? "0" : (v === null || v === undefined || v === "") ? "\u00A0" : v;

function pad2(n) { return String(n).padStart(2, "0"); }
function fmtDate(d) {
if (!d) return "";
const x = d instanceof Date ? d : new Date(d);
if (isNaN(x.getTime())) return String(d);
return `${pad2(x.getDate())}.${pad2(x.getMonth()+1)}.${x.getFullYear()}`;
}
function nbsp(v) { return (v === 0 ? "0" : (v == null || v === "") ? "\u00A0" : v); }


  return (
  <div className="print-page first cemt-page">
      {/* ======= GORNJI LEVI BLOK (Republika...) ======= */}
      <div className="rs-header">
        <p>Република Србија</p>
        <p>Министарство грађевинарства,</p>
        <p>саобраћаја и инфраструктуре</p>
        <p>Немањина 22–26</p>
        <p>11000 Београд</p>
      </div>

      {/* ======= GORNJI DESNI BLOK: Broj / Datum ======= */}
      <div className="top-right">
        <div className="row">
          <span>Број:</span>
          <span className="line">{nbsp(zavodniBroj || " ")}</span>
        </div>
        <div className="row">
          <span>Датум:</span>
          <span className="line">{fmtDate(datumKreiranja)}</span>
        </div>
      </div>

      {/* ======= SREDIŠNJI PODNOSILAC (naziv i adresa) ======= */}
      <div className="applicant">
        <div className="name">{nbsp(firma)}</div>
        <div className="hint">(назив и адреса подносиоца захтева)</div>
        <div className="addr">{nbsp(adresaFirma)}</div>
      </div>

      {/* ======= UVODNI TEKST ======= */}
      <p className="lead">
        На основу Правилника о техничким и техничко-експлоатационим условима које морају испуњавати
        теретна возила или скупови возила којима се обавља превоз у друмском саобраћају и о образцима
        потврда о испуњавању ових услова („Службени гласник РС“ бр. 14/17) (у даљем тексту: Правилник)
        подноси
      </p>

      {/* ======= NASLOV ======= */}
      <div className="titleBox">
        <h1 className="title cemt-title">З А Х Т Е В</h1>
      </div>

      {/* ======= U T I M E ======= */}
      <div className="u-ime">
        У циљу:
          <div>
            I Oзначавања јединственом нумерацијом сходно чл. 15. правилника Потврде за „зелено“
            возило (у прилогу) из чл. 2. правилника (односи се само на „зелена“ возила);
          </div>
          <div>
            II Добивање Потврде ЦЕМТ о способностима теретног или прикључног возила за коришћење у
            друмском саобраћају сходно чл. 14. правилника за возила која имају нумерацију из чл.
            3–13. правилника (у прилогу) и означавање јединственом нумерацијом (односи се на сва возила осим „зеленог“);
          </div>
    
      </div>

      {/* ======= PODACI O VOZILU ======= */}
      <div className="section-title">ПОДАЦИ О ВОЗИЛУ:</div>

      <div className="vozilo-grid">
        <div className="lbl">Марка и тип возила:</div>
        <div className="val underline">{nbsp(markaItip)}</div>

        <div className="lbl">Врста возила:</div>
        <div className="val underline">{nbsp(vrstaVozila)}</div>

        <div className="lbl">VIN ознака возила:</div>
        <div className="val underline">{nbsp(VIN)}</div>

        <div className="lbl">Тип мотора / Бр. мотора:</div>
        <div className="val underline">{nbsp(brojMotora)}</div>

        <div className="lbl">Регистрацијa број возила:</div>
        <div className="val underline">{nbsp(registracija)}</div>

        <div className="lbl">Година производње возила:</div>
        <div className="val underline">{nbsp(godinaProizvodnje)}</div>
      </div>


      {/* ======= IZJAVA ======= */}
      <p className="lead">
        Изјављујемо да преузимамо све обавезе које произилазе из поступка спровођења Правилника,
        односно посебних захтева према Уредби о условима за обављање превоза („Службени лист СРФ“
        бр. 51/98). Уз овај Захтев (у два примерка) у подношењу потребну техничку документацију према
        Прилогу 1 (у два примерка).
      </p>

      {/* ======= U PRILOGU (checkbox lista) ======= */}
      <div className="section-title">У прилогу:</div>
      <ul className="check-list">
        <li>- Потврда за „ЗЕЛЕНО“ возило</li>
        <li>- Потврда за „ЗЕЛЕНЕ И БЕЗБЕДНО“ возило</li>
        <li>- Потврда за „ЕУРО 3“ безбедно возило</li>
        <li>- Потврда за „ЕУРО 4“ безбедно возило</li>
        <li>- Потврда за „ЕУРО 5“ безбедно возило</li>
        <li>- Потврда за „EEV“ безбедно возило</li>
        <li>- Потврда за „ЕУРО 6“ безбедно возило</li>
        <li>- Потврда за прикључно возило</li>
        <li>- Доказ о уплати таксе</li>
      </ul>

      {/* ======= POTPIS ======= */}
      <div className="footer-sign">
        <div className="mp">
          <p>{'1) Потребно означити заокруживањем редног броја'}</p>
          <p>{'2) Не примењује се на приколице (полуприколице)'}</p>
        </div>
        <div className="potpisnik">
          <p className="hint">За подносиоца захтева:</p>
          <div className="hint">ДИРЕКТОР</div>
          <div className="line" />
          <div className="hint">(фукнција)</div>
          <div className="line" />
          <div className="name2">Dušan Šarčević</div>
        </div>
      </div>
    </div>
  );
};

export default AkontacijaStrana;
